import './SiteHeader.css';
import { BrandLogoLink } from '../BrandLogo';

const NAV_LINKS = [
  { label: 'About', hash: 'about' },
  { label: 'Review Lumen x Paige', hash: 'review-lumen-x-paige' },
  { label: 'Pricing', hash: 'pricing' },
] as const;
const APP_LOGIN_URL = 'https://app.reviewlumen.com/';

export function SiteHeader() {
  return (
    <header className="header">
      <div className="container header__inner">
        <div className="header__start">
          <BrandLogoLink className="brand-logo--header" mobileAppIcon />

          <nav className="nav" aria-label="Main navigation">
            <ul className="nav__list">
              {NAV_LINKS.map(({ label, hash }) => (
                <li key={hash}>
                  <a href={`/#${hash}`}>{label}</a>
                </li>
              ))}
            </ul>
          </nav>
        </div>

        <div className="header__actions">
          <a
            href={APP_LOGIN_URL}
            className="btn btn--outline"
            target="_blank"
            rel="noopener noreferrer"
          >
            Login
          </a>
          <a href="/#pricing" className="btn btn--dark">
            Start getting reviews
          </a>
        </div>
      </div>
    </header>
  );
}
